import Ping from "ping.js"
import store from "../../storage"
import bus from "../BusEmisor";
import api from "../api";

export default () => {

	const handler = () => {
		const p = new Ping();
		//   https://kllaar.com
		p.ping("https://api.kllaar.com/", (err) => {
			if (err || !navigator.onLine) {
				store.commit("setOnlineStatus", false);
				bus.$emit("connection-change", false);
				api.post("auth/get-user");
				console.log('navigator.onLine')
			} else {
				console.log('navigator.offLine')
				store.commit("setOnlineStatus", true);
				bus.$emit("connection-change", true)
			}
		});
	};

	window.addEventListener("offline", () => {
		handler()
	});

	window.addEventListener("online", () => {
		handler()
	});
}



// WEBPACK FOOTER //
// ./src/js/connection/status.js